<template>
  <div class="payout-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.complete_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.loan_transaction_no') }}</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_status') }}</div>
              <el-select v-model="search.transaction_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in loanStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.bill_no') }}</div>
              <el-input v-model="search.loan_order_no" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id_wallet') }}</div>
              <el-input v-model="search.payment_no" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item" />
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <!--              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>-->
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>
    <div class="total-container">
      <div class="total-item">{{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_fee | toDivideWithDot }}</span>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.loan_transaction_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.transaction_id_wallet')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.repayment_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.bill_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.loan_order_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.amount')" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.down_payment_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.down_payment_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.installment_amount_wallet')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.loan_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.loan_type')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ getLoanTypeMap(scope.row.loan_type).label }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.status')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ getLoanStatusMap(scope.row.transaction_status).label }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.complete_time }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
            <el-tooltip v-if="scope.row.transaction_status === 3" placement="top">
              <div slot="content">
                <span> {{ $t('customerService.bill') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-create-payment" @click="onClickBillDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <loan-details-modal ref="LoanDetailsModal" :detail-id="detailId" />
    <loan-bill-details-modal ref="loanBillDetailsModal" :detail-id="detailId" />
  </div>
</template>

<script>

import { getCreditLoanList } from '@/api/settlement/settlement'
import { filterEmptyAttr } from '@/utils/common'

import { appointDate } from '@/utils/index.js'
import { loanStatusMap, loanTypeMap } from '@/maps/status'
export default {
  name: 'Payout_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    LoanDetailsModal: () => import('./Modal/LoanDetailsModal.vue'),
    LoanBillDetailsModal: () => import('./Modal/LoanBillDetailsModal.vue')
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: []
      },
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    loanStatusMap() {
      return loanStatusMap()
    },
    getLoanStatusMap() {
      return function(value) {
        return loanStatusMap(value)
      }
    },
    getLoanTypeMap() {
      return function(value) {
        return loanTypeMap(value)
      }
    }
  },
  mounted() {
    this.handleFilter()
  },
  methods: {
    getCreditLoanList(params = {}) {
      this.listLoading = true
      getCreditLoanList(params).then(res => {
        const { total, total_count, list = [], total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total_count
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [], complete_times = [], ...otherSearch } = this.search
      let params = {
        create_start_date_time: times && times[0],
        create_end_date_time: times && times[1],
        complete_start_date_time: complete_times && complete_times[0],
        complete_end_date_time: complete_times && complete_times[1],
        ...otherSearch,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getCreditLoanList(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    showPayDetailModal() {
      this.$refs.LoanDetailsModal.changModalStatus(true)
    },

    onClickBillDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showBillDetailModal()
    },

    showBillDetailModal() {
      this.$refs.loanBillDetailsModal.changModalStatus(true)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
   .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 5px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }

}

</style>
